module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/core-js/modules/_html.js
// module id = 49
// module chunks = 0 3 5